// @flow strict

import * as React from 'react'
import cx from 'classnames'

import styles from './BusinessButton.module.scss'
import Button, { type Props as ButtonProps } from '.'

const BusinessButton = (props: ButtonProps) => {
  const { theme, className } = props
  return (
    <Button
      {...props}
      className={cx(
        styles.BusinessButton,
        theme === 'secondary'
          ? styles.BusinessButtonSecondary
          : styles.BusinessButtonPrimary,
        className,
      )}
    >
      {props.children}
    </Button>
  )
}

export default BusinessButton
